export const APP_ID = 'applicationIds';
export const PERIOD = 'period';

export const DEFAULT_APP = 27;
